var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#49C1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.0625 4.09556L11.3141 7.1235L12.9144 6.40237L6.68869 3.375L5.0625 4.09556Z",
    fill: "white",
    fillOpacity: 0.304
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3141 7.11607L12.9144 6.39551V8.00707L11.3141 8.72763V7.11607ZM11.3141 14.5883V9.56126L12.9144 8.83282V13.8678L11.3141 14.5883Z",
    fill: "white",
    fillOpacity: 0.646
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.0625 4.09717V5.72673L9.38981 7.82879L5.0625 9.97192V11.5784L11.3141 14.6007V12.9841L7.06838 10.9192L11.3141 8.73611V7.12454L5.0625 4.09717Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32591"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZil);
export default __webpack_public_path__ + "static/media/zil.237c888f0a52d83e5b2fd767e38eeb61.svg";
export { ForwardRef as ReactComponent };